<!--
  Capture Toast
  =============
  Bottom-center singleton toast shown immediately after a successful capture.
  Caption is bound through a reactive FormControl; the host persists via the
  (captionChange) output (debounced) and on any button press.
-->
<div *ngIf="screenshot as s" class="capture-toast" @slideInUp role="dialog" aria-label="Screenshot captured">
  <!-- Thumbnail with success check overlay -->
  <div class="capture-toast-thumb">
    <img [src]="s.thumbnail" [alt]="s.caption || 'Captured screenshot'" />
    <span class="capture-toast-thumb-check" aria-hidden="true">
      <mat-icon>check</mat-icon>
    </span>
  </div>

  <!-- Content + actions -->
  <div class="capture-toast-body">
    <div class="capture-toast-row">
      <div class="capture-toast-meta">
        <span class="capture-toast-page">{{ s.pageName }}</span>
        <span class="capture-toast-dims">
          {{ s.region.width | number:'1.0-0' }} × {{ s.region.height | number:'1.0-0' }} px
        </span>
      </div>
    </div>

    <label class="capture-toast-caption-label">
      <input
        class="capture-toast-caption-input"
        type="text"
        placeholder="Add a caption…"
        autofocus
        [formControl]="captionControl"
        (focus)="onCaptionFocus()"
        (blur)="onCaptionBlur()"
        aria-label="Screenshot caption"
      />
    </label>

    <div class="capture-toast-actions">
      <button
        type="button"
        class="capture-toast-btn capture-toast-btn-primary"
        (click)="onAnnotate()"
      >
        <mat-icon>edit</mat-icon>
        <span>Annotate</span>
      </button>
      <button
        type="button"
        class="capture-toast-btn capture-toast-btn-success"
        (click)="onShare()"
      >
        <mat-icon>share</mat-icon>
        <span>Share</span>
      </button>
      <button
        type="button"
        class="capture-toast-btn capture-toast-btn-neutral"
        (click)="onLink()"
      >
        <mat-icon>link</mat-icon>
        <span>Link</span>
      </button>
      <button
        type="button"
        class="capture-toast-btn capture-toast-btn-ghost"
        (click)="onDone()"
      >
        Done
      </button>
    </div>
  </div>
</div>
